import * as d3 from 'd3-format';
import {colors, lightGrey} from "@/style/layerStyles.js";

const popLegend= {
    title: "Population",
    data: [
        {color: "#FFFFB2", label:"Less"},
        {color: "#FD8D3C", label:""},
        {color: "#BD0026", label:"More"},
    ]
}

function namedToLegend(obj, name) {
    const legend = Object.entries(obj).map(([key, val]) => {
        return {color: val, label: key};
    });
    return {title: obj[name], data: legend};
}

function getSteps(values, key) {
    if (values.length === 0) return null
    const nbSteps = colors[key].length;
    const vals = [...new Set(values)];
    const hasNull = vals.includes(null);
    const intervalSize = Math.floor(vals.length/nbSteps);
    vals.sort((a, b) => a - b);
    if (!hasNull) return [...Array(nbSteps).keys()].map(i => vals[i * intervalSize]);
    vals.splice(0, 1);
    const steps = [...Array(nbSteps).keys()].map(i => vals[i * intervalSize])
    return [null, ...steps];
}

function stepsToLegend(steps, name, layerKey) {
    const cols = colors[layerKey];
    const legend = [];
    let appendNa = false;
    if (steps[0] == null) {
        steps.splice(0, 1);
        appendNa = true;
    }
    const coloredSteps = steps.map((s, i) => [s, cols[i]]);
    const mean = steps.reduce((acc, cur) => acc + cur, 0) / steps.length;
    let f = d3.format(',.2s');
    if (mean < 5) f = d3.format(',.4f');
    for (let i = coloredSteps.length - 1; i >= 0; --i) {
        const cur = coloredSteps[i];
        if (i == coloredSteps.length - 1) {
            legend.push({color: cur[1], label: `> ${f(cur[0])}`});
            continue;
        }
        const prev = coloredSteps[i  + 1];
        if (!i) legend.push({color: cur[1], label: `< ${f(prev[0])}`});
        else legend.push({color: cur[1], label: `${f(cur[0])} - ${f(prev[0])}`});
    }
    if (appendNa) legend.push({color: lightGrey, label: 'N/A'});
    return {title: name, data: legend, layerKey: layerKey};
}



export {popLegend, stepsToLegend, namedToLegend, getSteps};